import { makeStyles } from '@fluentui/react-components';
import { tokens, useFluentTokens } from '../../../../../theme/fluent';

const cardLinkStyle = makeStyles({
  root: {
    display: 'flex',
    gap: tokens.spacingVerticalS,
  },
  link: {
    display: 'flex',
    padding: `${tokens.spacingVerticalXXS} ${tokens.spacingHorizontalS}`,
    borderRadius: tokens.borderRadiusXLarge,
    fontSize: tokens.fontSizeBase200,
    lineHeight: tokens.lineHeightBase200,
    textDecoration: 'none',
    fontWeight: tokens.fontWeightRegular,
    minHeight: tokens.spacingVerticalXXL,
  },
});

export const useCardLinksStyles = () => {
  const classes = cardLinkStyle();
  const { modeTokens } = useFluentTokens();

  const linkStyle = {
    color: modeTokens.colorNeutralForeground1,
    backgroundColor: modeTokens.colorNeutralBackground1,
    border: `1px solid ${modeTokens.colorNeutralStroke1}`,
  };

  return { classes, linkStyle };
};
